module.exports = __webpack_public_path__ + "static/img/android.cc1ca59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android.png
// module id = 66
// module chunks = 1